import { Box } from '@mui/material'
import { useAtomValue } from 'jotai'
import { mainTabAtom } from '@/atoms'
import { AppHeader } from '@/components/view/AppHeader'
import { TierSidebarPanel } from '@/components/view/TierSidebarPanel'
import { RecipeListPanel } from '@/components/view/RecipeListPanel'
import { ItemSearchPanel } from '@/components/view/ItemSearchPanel'
import { GatheringListPanel } from '@/components/view/GatheringListPanel'
import { GatheringSidebarPanel } from '@/components/view/GatheringSidebarPanel'

export default function App() {
  const mainTab = useAtomValue(mainTabAtom)

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateAreas: `
          "header  header  header"
          "sidebar main    search"
        `,
        gridTemplateColumns: '15% 55% 30%',
        gridTemplateRows: 'auto 1fr',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <AppHeader />

      {mainTab === 'crafting' ? (
        <>
          <TierSidebarPanel />
          <RecipeListPanel />
        </>
      ) : (
        <>
          <GatheringSidebarPanel />
          <GatheringListPanel />
        </>
      )}

      <ItemSearchPanel />
    </Box>
  )
}
